import React, { useState, useEffect } from "react";
import "./Style.css";
import { Helmet } from 'react-helmet';
import fineinspect from './assets/fine-inspect.png';
import oncogen from './assets/oncogen.png';
import skc from './assets/skc.png';
import cap from './assets/cap.png';
import kensha from './assets/kensha.png';
import prime from './assets/prime.png';
import lawless from './assets/lawless.png';
import quietware from './assets/quiet-ware.png';
import royalshalimar from './assets/royalshalimar.png';
import kidneyfoundation from './assets/kidneyfoundation.png';
import bloombornekids from './assets/bloombornekids.png';
import techventuresconsulting from './assets/techventuresconsulting.png';
import quantum24energy from './assets/quantum24energy.png';
import creativepulse from './assets/creativepulse.png';
import gunsandarmor from './assets/gunsandarmor.png';
import esteembuilders from './assets/esteembuilders.png';
import ottagy from './assets/ottagy.png';
import radiscale from './assets/radiscale.png';
import parachadental from './assets/parachadental.png';
import thetrustedspace from './assets/thetrustedspace.png';

const Portfolio = () => {
    const images = [
        { id: 1, src: thetrustedspace, alt: "thetrustedspace", categories: ["development"], portfolioPath: "https://thetrustedspace.com/" },
        { id: 2, src: bloombornekids, alt: "Bloom borne kids", categories: ["development"], portfolioPath: "https://bloombornekids.com.au/" },
        { id: 3, src: parachadental, alt: "Paracha Dental", categories: ["development"], portfolioPath: "https://parachadental.com/" },
        { id: 4, src: kensha, alt: "Kensha", categories: ["development", "performance"], portfolioPath: "https://kensha.net/" },
        { id: 5, src: creativepulse, alt: "Creative Pulse", categories: ["development"], portfolioPath: "https://creativepulse.com.pk" },
        { id: 6, src: skc, alt: "SKC Japan", categories: ["development"], portfolioPath: "https://skcjapan.com/" },
        { id: 7, isVideo: true, alt: "Animated Blob Media", categories: ["plugins"], portfolioPath: "/blob-plugin" },
        { id: 8, src: techventuresconsulting, alt: "Tech ventures consulting", categories: ["development"], portfolioPath: "https://techventuresconsulting.com/" },
        { id: 9, src: cap, alt: "CAP Fabricator", categories: ["development"], portfolioPath: "https://capfabricator.com/" },
        { id: 10, src: gunsandarmor, alt: "Guns and armor", categories: ["development"], portfolioPath: "https://gunsandarmor.pk/" },
        { id: 11, src: esteembuilders, alt: "Esteem builders", categories: ["development"], portfolioPath: "https://esteembuilders.com.pk/" },
        { id: 12, src: royalshalimar, alt: "Royal Shalimar", categories: ["development"], portfolioPath: "https://royalshalimar.co.uk/" },
        { id: 13, src: fineinspect, alt: "Fire Inspect Victoria", categories: ["development"], portfolioPath: "http://fireinspectvictoria.com.au/" },
        { id: 14, src: oncogen, alt: "Oncogen", categories: ["development"], portfolioPath: "https://oncogenpharma.com.pk/" },
        { id: 15, src: kidneyfoundation, alt: "Kidney Foundation", categories: ["development"], portfolioPath: "https://kidneyfoundation.net.pk/" },
        { id: 16, src: radiscale, alt: "Radi Scale", categories: ["development"], portfolioPath: "https://radiscale.dotlocalhost.com/" },
        { id: 17, src: ottagy, alt: "Ottagy", categories: ["development"], portfolioPath: "https://ottagy.com/" },
        { id: 18, src: quantum24energy, alt: "Quantum 24 energy", categories: ["development"], portfolioPath: "https://quantum24energy.com/" },
        { id: 19, src: prime, alt: "Prime", categories: ["social"], portfolioPath: "https://www.facebook.com/p/Prime-Sports-Nutrition-100065275410750/" },
        { id: 20, src: lawless, alt: "Lawless", categories: ["social"], portfolioPath: "https://www.facebook.com/lawlesslabs/" },
        { id: 21, src: quietware, alt: "Quiet Ware", categories: ["social"], portfolioPath: "https://quietwaredishes.com/" },
    ];

    const categories = ["all", "development", "plugins", "performance", "social"];

    const [selectedCategory, setSelectedCategory] = useState("all");
    const [filteredImages, setFilteredImages] = useState(images);
    const [animationState, setAnimationState] = useState("zoom-in");

    useEffect(() => {
        setAnimationState("zoom-out");
        const timer = setTimeout(() => {
            setFilteredImages(
                selectedCategory === "all"
                    ? images
                    : images.filter((img) => img.categories.includes(selectedCategory))
            );
            setAnimationState("zoom-in");
        }, 500);

        return () => clearTimeout(timer);
    }, [selectedCategory]);

    return (
        <>
            <Helmet>
                <title>DotLocalHost Portfolio - Showcasing Web Design & Development Success</title>
                <meta
                    name="description"
                    content="Check out DotLocalHost’s portfolio of stunning websites and innovative projects. See how we turn ideas into powerful digital experiences!"
                />
            </Helmet>
            <div className="portfolio-section py-5">
                <div className="container">
                    <h2 className="section-tagline">PORTFOLIO</h2>
                    <p>Our Work</p>

                    <div className="portfolio-container">
                        <div className="tabs">
                            {categories.map((category) => (
                                <button
                                    key={category}
                                    className={`tab ${selectedCategory === category ? "active" : ""}`}
                                    onClick={() => setSelectedCategory(category)}
                                >
                                    {category.charAt(0).toUpperCase() + category.slice(1)}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="portfolio-section py-5">
                    <div className="container">
                        <div className={`gallery ${animationState}`}>
                            {filteredImages.map((image) => (
                                <div key={image.id} className="image-box">
                                    <a style={{textDecoration: 'none'}} href={image.portfolioPath} target="_blank" rel="noopener noreferrer">

                                        {image.isVideo ? (
                                            <div style={{ margin: '0 auto', maxWidth: '100%' }}>
                                                <div className="live-blob float-animation">
                                                    Live Demo
                                                </div>
                                                <p style={{
                                                    color: '#777',
                                                    fontSize: '0.8rem',
                                                    marginTop: '10px',
                                                    textAlign: 'center',                                                    
                                                }}>
                                                    ✨ Blob shape changes every 2 seconds
                                                </p>
                                            </div>
                                        ) : (
                                            <img src={image.src} alt={image.alt} />
                                        )}

                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Portfolio;